import { QueryParamConfig, UrlUpdateType, useQueryParam, withDefault } from 'use-query-params';
import { ITabItem } from 'components/tab-filter/tab-item/tab-item';
import { useIntl } from 'react-intl';

export const TYPE_QUERY_KEY = 'type';

type NewValueType<D> = D | ((latestValue: D) => D);

const GetTabItems = (): ITabItem[] => {
	const { formatMessage } = useIntl();

	return [
		{
			id: 'pages',
			label: formatMessage({ id: 'modules.search.tabs.pages' }, { count: 0 })
		},
		{
			id: 'internal',
			label: formatMessage({ id: 'modules.search.tabs.internalInformation' }, { count: 0 })
		}
	];
};

export type UseTypeReturn = {
	selectedType: ITabItem;
	setSelectedType: (
		newValue: NewValueType<ITabItem | undefined | null>,
		updateType?: UrlUpdateType | undefined
	) => void;
};

export const useType = (): UseTypeReturn => {
	const defaultTypeParam: ITabItem = GetTabItems()[0];
	const [selectedType, setSelectedType] = useQueryParam(TYPE_QUERY_KEY, withDefault(TypeParam, defaultTypeParam));

	return {
		selectedType,
		setSelectedType
	};
};

export const TypeParam: QueryParamConfig<ITabItem | undefined | null, ITabItem | undefined | null> = {
	encode: (type) => {
		return type?.id;
	},
	decode: (param) => {
		return param === 'internal' ? GetTabItems()[1] : GetTabItems()[0];
	}
};
